import { ADDRESS } from "@/remotes";
import { useDataFormStore } from "@/stores/form";
import { getArrayOfRules } from "@/utils/getDataForm";
import { debounce } from "@/utils/setDebounce";
import { ref } from "vue";

export default {
  setup() {
    const dataForm = useDataFormStore();
    // Инициализируем лист адресов
    const toAddressList = ref({});

    // Инициализируем выпадающий список
    const addressDropdown = ref();

    // Получаем адреса с API и подставляем в список (значение, город отправки)
    async function getAddressList(value, cityTo) {
      if (value.length > 1) {
        try {
          const { data } = await ADDRESS.post('4_1/rs/suggest/address', { query: value, locations: [{"city": cityTo}], restrict_value: true });
          toAddressList.value = data.suggestions;
          if (toAddressList.value.length < 1) {
            toAddressList.value[0] = {disabled: "true", class: "disable-notice", value: "Нет результатов"};
            addressDropdown.value.handleOpen()
          } else {
            toAddressList.value.unshift({disabled: "true", class: "disable-notice" ,value: "Выберите нужный адрес"});
            addressDropdown.value.handleOpen()
          }
        } catch (e) {
          console.log(e);
        }
      }
      else {
        addressDropdown.value.handleClose()
      }
    }

    // Создаем задержку запроса в 1 секунду
    const getAddressDebounce = debounce(getAddressList, 500)

    // Пропуск запуск
    getAddressDebounce("", dataForm.consignee.cityTo)

    const typeOfCargos = [
      {
        value: "Стандарт",
        label: "Стандарт",
      },
      {
        value: "Цилиндры",
        label: "Цилиндры",
      },
      {
        value: "Шины",
        label: "Шины",
      },
    ];
    const typeOfPackagings = [
      {
        value: "Обрешётка",
        label: "Обрешётка",
        disabled: [
          "Обрешётка",
          "Стретч-пленка",
          "Коробка 25x18x10",
          "Коробка 38x30x23",
          "Пакет",
        ],
      },
      {
        value: "Паллетирование",
        label: "Паллетирование",
        disabled: [
          "Паллетирование",
          "Стретч-пленка",
          "Коробка 25x18x10",
          "Коробка 38x30x23",
          "Пакет",
        ],
      },
      {
        value: "Стретч-пленка",
        label: "Стретч-пленка",
        disabled: [
          "Обрешётка",
          "Паллетирование",
          "Стретч-пленка",
          "Коробка 25x18x10",
          "Коробка 38x30x23",
          "Пакет",
          "Поддон",
        ],
      },
      {
        value: "Коробка 25x18x10",
        label: "Коробка 25x18x10",
        disabled: [
          "Обрешётка",
          "Паллетирование",
          "Стретч-пленка",
          "Коробка 25x18x10",
          "Поддон",
        ],
      },
      {
        value: "Коробка 38x30x23",
        label: "Коробка 38x30x23",
        disabled: [
          "Обрешётка",
          "Паллетирование",
          "Стретч-пленка",
          "Коробка 38x30x23",
          "Поддон",
        ],
      },
      {
        value: "Пакет",
        label: "Пакет",
        disabled: ["Обрешётка", "Паллетирование", "Стретч-пленка", "Пакет"],
      },
      {
        value: "Поддон",
        label: "Поддон",
        disabled: [
          "Стретч-пленка",
          "Коробка 25x18x10",
          "Коробка 38x30x23",
          "Пакет",
          "Поддон",
        ],
      },
    ];

    function checkIntersectionsTypes(types, typeName) {
      return !(
        dataForm.cargoInformation.typeOfPackaging.filter((type) =>
          types.includes(type)
        ).length === dataForm.cargoInformation.typeOfPackaging.length &&
        checkWarmPlace(typeName)
      );
    }

    function checkWarmPlace(typeName) {
      if (!dataForm.services.warmPlace) {
        return true;
      }
      return typeName === "Паллетирование" || typeName === "Поддон"
        ? false
        : true;
    }

    function checkingDimensions(dimensions) {
      dimensions.sort((a, b) => b - a);
      return dimensions[0] > 100 || dimensions[1] > 70;
    }

    function isBoxesOnly() {
      return ![...dataForm.cargoInformation.typeOfPackaging].reduce(
        (prevtype, curtype) =>
          prevtype &&
          !(curtype.includes("Поддон") || curtype.includes("Паллетирование")),
        true
      );
    }

    return {
      toAddressList,
      dataForm,
      getAddressDebounce,
      typeOfCargos,
      typeOfPackagings,
      checkIntersectionsTypes,
      getArrayOfRules,
      addressDropdown,

      checkNumberOfIdenticalLoads: function () {
        if (dataForm.cargoInformation.numberOfIdenticalLoads < 1) {
          dataForm.cargoInformation.numberOfIdenticalLoads = 1;
        }
      },

      checkCargoCost: function () {
        if (dataForm.cargoInformation.cargoCost < 3000) {
          dataForm.cargoInformation.cargoCost = 3000;
        }
        if (dataForm.cargoInformation.cargoCost >= 30000) {
          // dataForm.cargoInformation.additionalPackaging = true
          // if (!dataForm.cargoInformation.typeOfPackaging.includes('Обрешётка')) {
          //   dataForm.cargoInformation.typeOfPackaging.push('Обрешётка')
          // }
        }
      },
      checkPackageType: function () {
        if (dataForm.cargoInformation.cargoCost >= 30000) {
          if (!dataForm.cargoInformation.typeOfPackaging.includes('Обрешётка')) {
            dataForm.cargoInformation.typeOfPackaging.push('Обрешётка')
          }
          console.log(dataForm.cargoInformation.typeOfPackaging)
        }
      },

      calculateVolume: function () {
        if (
          dataForm.cargoInformation.cargoDimensions.length &&
          dataForm.cargoInformation.cargoDimensions.width &&
          dataForm.cargoInformation.cargoDimensions.height
        ) {
          dataForm.cargoInformation.cargoVolume =
            (dataForm.cargoInformation.cargoDimensions.length *
              dataForm.cargoInformation.cargoDimensions.width *
              dataForm.cargoInformation.cargoDimensions.height) /
            1000000;
        }
      },

      checkDisabledWarmplace: function () {
        if (
          isBoxesOnly() ||
          Number(dataForm.cargoInformation.cargoVolume) > 0.5 ||
          dataForm.cargoInformation.cargoWeight > 30 ||
          checkingDimensions([
            dataForm.cargoInformation.cargoDimensions.length,
            dataForm.cargoInformation.cargoDimensions.width,
            dataForm.cargoInformation.cargoDimensions.height,
          ])
        ) {
          dataForm.services.warmPlace = false;
          return true;
        }
        return false;
      },

      handlerCashOnDelivery: function () {
        dataForm.services.cargoRedemption = false
      },
      clickAddress: function () {
        if (dataForm.applicationCargoPickup.addressConsignee.length <= 1){
          addressDropdown.value.handleClose()
        } else {
          addressDropdown.value.handleOpen()
        }
      },
      // Вызываем функцию при вводе значений в поле
      getAddress: function () {
        if (dataForm.applicationCargoPickup.addressConsignee.length <= 1){
          addressDropdown.value.handleClose();
          toAddressList.value = [];
        } else {
          addressDropdown.value.handleOpen()
          toAddressList.value[0] = {disabled: "true", class: "disable-notice", value: "Поиск..."};
        }
        getAddressDebounce(dataForm.applicationCargoPickup.addressConsignee, dataForm.consignee.cityTo)
      },
      setAddress: function (value) {
        dataForm.applicationCargoPickup.addressConsignee = value
      }
    };
  },
};
